<div class="change-password-container">

  <div class="logo-container">
    <img src="assets/logo_tipay.svg" alt="Logo" class="logo" />
  </div>

  <h2>Changement de mot de passe</h2>

    <p class="subtitle">
    Pour des raisons de sécurité, vous devez modifier votre mot de passe avant de continuer.
    </p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">


    <div class="form-group">
      <label for="oldPassword">Ancien mot de passe *</label>
      <input id="oldPassword" type="password" formControlName="oldPassword" />
      <div *ngIf="form.get('oldPassword')?.touched && form.get('oldPassword')?.invalid" class="error">
        Champ requis
      </div>
    </div>


    <div class="form-group">
      <label for="newPassword">Nouveau mot de passe *</label>
      <input id="newPassword" type="password" formControlName="newPassword" />

      <!--<button type="button" data-toggle-password='{ "target": "#toggle-password" }' class="block cursor-pointer" aria-label="password toggle" >
        <span class="icon-[tabler--eye] text-base-content/80 password-active:block hidden size-5 shrink-0"></span>
        <span class="icon-[tabler--eye-off] text-base-content/80 password-active:hidden block size-5 shrink-0"></span>
      </button>-->


      <div
        *ngIf="
          form.get('newPassword')?.touched &&
          form.get('newPassword')?.errors?.['minlength']
        "
        class="error"
      >
        Le mot de passe doit contenir au moins 6 caractères.
      </div>
    </div>



    <div class="form-group">
      <label for="confirmPassword">Confirmer mot de passe *</label>
      <input id="confirmPassword" type="password" formControlName="confirmPassword" />
      <div *ngIf="form.errors?.['passwordMismatch'] && form.get('confirmPassword')?.touched" class="error">
        Les mots de passe ne correspondent pas
      </div>
    </div>


    <!-- <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
    <div *ngIf="successMessage" class="success-message">{{ successMessage }}</div> -->


    <button type="submit" [disabled]="form.invalid || loading">
      {{ loading ? 'Chargement...' : 'Valider' }}
    </button>
  </form>
</div>
